import React, { useCallback, useEffect, useState } from 'react';

import DateUtils from 'js/lib/DateUtils';
import { Typography } from '@mui/material';
import { usePollingConfig } from 'new/hooks/usePollingConfig';

interface Props {
  prefix?: string;
  lastRequestTime: number;
}

const LastRequestTimeIndicator = (props: Props) => {
  const { prefix = 'Updated', lastRequestTime } = props;
  // Use UI_TIME_DISPLAY preset (10s) - client-side only, no API calls
  const { intervalMs } = usePollingConfig('UI_TIME_DISPLAY');

  const [timeAgo, setTimeAgo] = useState('');

  const updateTimeAgo = useCallback(() => {
    const timeAgoString = DateUtils.showTimeSince(lastRequestTime);
    setTimeAgo(timeAgoString);
  }, [lastRequestTime]);

  useEffect(() => {
    updateTimeAgo();
    // Use centralized polling interval from config
    const intervalReference = setInterval(updateTimeAgo, intervalMs);
    return () => clearInterval(intervalReference);
  }, [lastRequestTime, intervalMs, updateTimeAgo]);

  if (!lastRequestTime) return null;

  return (
    <Typography variant="body2">
      {prefix} {timeAgo}
    </Typography>
  );
};

export { LastRequestTimeIndicator };
